import { render, staticRenderFns } from "./RoomEditForm.vue?vue&type=template&id=620182ae&lang=pug&"
import script from "./RoomEditForm.vue?vue&type=script&lang=js&"
export * from "./RoomEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomEditForm.vue"
export default component.exports